import React from "react";
import { Mail } from "lucide-react";
import PublicPageLayout from "../components/PublicPageLayout";

export default function Contact() {
  return (
    <PublicPageLayout
      eyebrow="Contact"
      title="Get in touch."
      subtitle="Questions, feedback, partnership ideas, or bug reports: we read everything that comes in."
    >
      <div className="not-prose glass rounded-2xl p-8 flex items-start gap-4">
        <div className="w-11 h-11 shrink-0 rounded-xl bg-primary/15 border border-primary/30 flex items-center justify-center">
          <Mail className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h3 className="font-heading text-lg font-semibold text-white">Email us</h3>
          <p className="text-zinc-400 text-sm mt-1">The fastest way to reach the team.</p>
          <a
            href="mailto:hello@adyap.in"
            data-testid="contact-email-link"
            className="inline-block mt-3 text-primary hover:underline font-medium"
          >
            hello@adyap.in
          </a>
        </div>
      </div>

      <p className="mt-8 text-zinc-400 text-sm">
        We typically reply within 1–2 business days. For account or billing issues, include the email address on
        your Adyap account so we can find you faster.
      </p>
    </PublicPageLayout>
  );
}
